import { Fragment, h } from 'preact';
import { useMemo } from 'preact/hooks';
import { UI_COMING_NEXT_BUTTON_SHOWN, UI_SKIP_INTRO_BUTTON_SHOWN, UI_SKIP_INTRO_CLICKED, UI_SKIP_RECAP_BUTTON_SHOWN, UI_SKIP_RECAP_CLICKED } from '../../../../store/types';
import { COMING_NEXT, NEXT, USER_REQUEST_MEDIA_LOAD } from '../../../../types';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import { mapTitleMetadata } from '../../../common/utils/tools';
import { withBreakPoints } from '../../hoc';
import { SKIP_BTN_INTRO_OVERRIDE } from '../common/buttons/styles';
import { SkipButton } from '../controls';
import FeedbackOverlays from '../feedback/FeedbackOverlay';
import { PIPView } from '../info';
import Spinner from '../spinner';
import TapLayer from './TapLayer';

function SectionOverlay({
  waitStart,
  handleTap,
  containerVisible,
  mobile,
  extraSmall
}) {
  const player = usePlayerContext();
  const { showSkipIntro, showSkipRecap, canComingNextButtonBeDisplayed, next, forceHidden, hasDialogOpened } = useNewStore('ui', player);
  const { id, title, preTitle, additionalTitle,
    skipIntro: { timecode: skipIntroTimeCode, duration: skipIntroDuration },
    skipRecap: { timecode: skipRecapTimeCode, duration: skipRecapDuration }
  } = useNewStore('media', player);
  const { isAd } = useNewStore('ad', player);
  const { playlist, playlistIdsAsString } = useNewStore('playlist', player);

  const playlistEnabled = playlist.length > 0;
  const showNextPlaylistBtn = playlistEnabled && playlist[playlist.length - 1].src !== id;
  const currentPlaylistVideo = useMemo(() => playlist.findIndex((v) => v.src === id), [id, playlistIdsAsString]);

  const getNextClickEvent = (isNext, isPlaylist) => {
    if (isNext) {
      return { name: NEXT, payload: COMING_NEXT };
    }

    if (isPlaylist) {
      const nextPlaylistVideo = currentPlaylistVideo + 1;
      const tracking = {
        /* position is the human readable version of the index, hence the +1 */
        diffusion: { mode: 'tunnel', position: nextPlaylistVideo + 1, length: playlist.length },
        tracking: {
          pageProvenance: '',
          zoneProvenance: 'playlist_player',
          positionVignette: '',
          playProvenance: 'tunnel_comingnext'
        },
        startTimecode: 0,
        ...mapTitleMetadata(playlist[nextPlaylistVideo], { title, preTitle, additionalTitle })
      };
      return {
        action: USER_REQUEST_MEDIA_LOAD,
        value: {
          from: 'coming_next',
          src: playlist[nextPlaylistVideo].src,
          config: {
            ...playlist[nextPlaylistVideo].config,
            intro: false,
            autostart: true,
            ...tracking
          }
        }
      };
    }
    return {};
  };
  return (
    <Fragment>
      <PIPView />
      <TapLayer
        /* TapLayer handles initial click to start player in autostart: false
        * and "tap to hide UI" behavior on mobile devices */
        isMobile={mobile}
        ariaLabel="lecture"
        onTap={waitStart ? () => player.play({ userGesture: true }) : handleTap}
        visible={(waitStart || (mobile && !containerVisible)) && !forceHidden}
      />
      <Spinner />
      <FeedbackOverlays hasDialogOpened={hasDialogOpened} />
      {(!extraSmall && !isAd && (
        <SkipButton
          duration={skipIntroDuration}
          timecode={skipIntroTimeCode}
          label="Passer le générique"
          show={showSkipIntro}
          trackingEvent={UI_SKIP_INTRO_BUTTON_SHOWN}
          style={SKIP_BTN_INTRO_OVERRIDE}
          clickEvent={UI_SKIP_INTRO_CLICKED}
        />
      ))}
      {(!extraSmall && !isAd && (
        <SkipButton
          duration={skipRecapDuration}
          timecode={skipRecapTimeCode}
          label="Passer le récap"
          show={showSkipRecap}
          trackingEvent={UI_SKIP_RECAP_BUTTON_SHOWN}
          clickEvent={UI_SKIP_RECAP_CLICKED}
        />
      ))}
      {(!extraSmall && !isAd && (next || showNextPlaylistBtn) && (
        <SkipButton
          label="Vidéo suivante"
          trackingEvent={UI_COMING_NEXT_BUTTON_SHOWN}
          show={canComingNextButtonBeDisplayed}
          clickEvent={getNextClickEvent(next, showNextPlaylistBtn)}
          seek={false}
        />
      ))}
    </Fragment>
  );
}

export default withBreakPoints(SectionOverlay);
